import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import SocialIcons from "../cards/SocialIcons";

import "./CategoryGrid.css";

export default function CategoryGrid() {
  const [resarch, setResarch] = useState([]);
  const [sports, setSports] = useState([]);
  const [it, setIt] = useState([]);
  const [multi, setMulti] = useState([]);
  const [health, setHealth] = useState([]);
  const [lajeen, setLajeen] = useState([]);
  const [featured, setFeatured] = useState([]);
  const [jobs, setJobs] = useState([]);
  const navigate = useNavigate();

  const slugify = (text) =>
    text?.toString().toLowerCase().trim()
      .replace(/\s+/g, '-')
      .replace(/[^\w\-ء-ي]/g, '')
      .replace(/\-\-+/g, '-');

  useEffect(() => {
    const fetchSection = (url, setter) =>
      axios.get(url).then((r) => setter(r.data)).catch(console.error);

    fetchSection("https://ppmn.net/dash/api/Section/resarech-news", setResarch);
    fetchSection("https://ppmn.net/dash/api/Section/sport-news", setSports);
    fetchSection("https://ppmn.net/dash/api/Section/it-news", setIt);
    fetchSection("https://ppmn.net/dash/api/Section/multi-news", setMulti);
    fetchSection("https://ppmn.net/dash/api/Section/health-news", setHealth);
    fetchSection("https://ppmn.net/dash/api/Section/lajeen-news", setLajeen);
    fetchSection("https://ppmn.net/dash/api/main/featured-news", setFeatured);
    fetchSection("https://ppmn.net/dash/api/all/job/ads", setJobs);
  }, []);

  const getCategoryKey = (title) => {
    switch (title) {
      case "أبحاث علمية": return "research-news";
      case "الرياضة": return "sport-news";
      case "التكنولوجيا": return "it-news";
      case "منوعات": return "multi-news";
      case "الصحة": return "health-news";
      case "شؤون اللاجئين": return "lajeen-news";
      default: return "";
    }
  };

  const getCategoryLink = (title) => {
    switch (title) {
      case "أبحاث علمية": return "/research";
      case "الرياضة": return "/sport";
      case "التكنولوجيا": return "/technology";
      case "منوعات": return "/entertainment";
      case "الصحة": return "/health";
      case "شؤون اللاجئين": return "/refugeeIssues";
      default: return "/";
    }
  };

  const CategoryCard = ({ title, data }) => {
    if (!Array.isArray(data)) return null;
    const main = data[0];
    const rest = data.slice(1, 4);
    const categoryKey = getCategoryKey(title);

    return (
      <div className="col-md-4 mb-4 d-flex">
        <div className="category-card p-3 rounded luxury-shadow w-100">
          <a href={getCategoryLink(title)} className="text-dark text-decoration-none">
            <h6 className="fw-bold section-title pb-2 mb-3" style={{ fontSize: "19px" }}>
              {title}
            </h6>
          </a>

          {main && (
            <div
              className="main-article mb-3 position-relative"
              onClick={() => navigate(`/News/${categoryKey}/${main.article_id}/${slugify(main.article_title)}`)}
              style={{ cursor: "pointer" }}
            >
              <img
                src={main.article_title_image}
                alt="main"
                className="w-100 rounded"
                style={{ height: "200px", objectFit: "cover" }}
              />
              <div className="overlay-title text-white position-absolute w-100 bottom-0 start-0 p-2">
                {main.article_title?.slice(0, 80)}…
              </div>
            </div>
          )}

          {[...rest, ...Array(3 - rest.length).fill(null)].map((a, index) =>
            a ? (
              <div
                key={a.article_id}
                className="d-flex mb-3 align-items-start small-article"
                onClick={() => navigate(`/News/${categoryKey}/${a.article_id}/${slugify(a.article_title)}`)}
                style={{ cursor: "pointer" }}
              >
                <img
                  src={a.article_title_image}
                  alt="thumb"
                  className="me-2 rounded"
                  style={{ width: "70px", height: "55px", objectFit: "cover" }}
                />
                <span
                  className="text-dark me-2"
                  style={{ fontSize: "16px", fontWeight: "500", lineHeight: "1.5" }}
                >
                  {a.article_title?.slice(0, 60)}…
                </span>
              </div>
            ) : (
              <div key={`empty-${index}`} className="d-flex mb-3" style={{ minHeight: "55px", visibility: "hidden" }}>
                <div style={{ width: "70px", height: "55px" }} />
                <div style={{ flex: 1, height: "55px" }} />
              </div>
            )
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="category-grid-section py-5">
      <div className="container">
        <div className="row">
          <div className="col-lg-9">
            <div className="row align-items-stretch">
              <CategoryCard title="أبحاث علمية" data={resarch} />
              <CategoryCard title="الرياضة" data={sports} />
              <CategoryCard title="التكنولوجيا" data={it} />
              <CategoryCard title="منوعات" data={multi} />
              <CategoryCard title="الصحة" data={health} />
              <CategoryCard title="شؤون اللاجئين" data={lajeen} />
            </div>
          </div>

          <div className="col-lg-3 d-flex flex-column">
            <div
              className="picked-box bg-dark text-white p-3 rounded luxury-shadow mb-4"
              style={{ height: "581px", overflowY: "auto" }}
            >
              <h5 className="fw-bold border-bottom pb-2 mb-3 text-danger loay">اخترنا لكم</h5>
              <ul className="list-unstyled small mb-0">
                {Array.isArray(featured) &&
                  featured.slice(0, 6).map((f) => (
                  
                    <li
                      key={f.article_id}
                      className="mb-2"
                      onClick={() => navigate(`/News/multi-news/${f.article_id}/${slugify(f.article_title)}`)}
                      style={{ cursor: "pointer" }}
                    >
                      <hr />
                      <span className="text-white text-decoration-none d-block">
                        {f.article_title.length > 80
                          ? f.article_title.slice(0, 80) + "…"
                          : f.article_title}
                      </span>
                    </li>
                
                  ))}
              </ul>
            </div>

            <div
              className="jobs-box bg-light p-2 rounded luxury-shadow"
              style={{ maxHeight: "600px", overflowY: "auto" }}
            >
              <div className="mb-3 text-center">
                <SocialIcons />
              </div>

              <h6 className="fw-bold border-bottom pb-2 mb-3 text-primary">فرص عمل متاحة</h6>
              


<ul className="list-unstyled small mb-0">
  {Array.isArray(jobs) &&
    jobs.map((job, index) => (
      <li key={index} className="mb-3 border-bottom pb-2">
        <div className="d-flex align-items-start">
          <img
            src={job.job_image || "/placeholder-job.png"}
            alt="job"
            style={{
              width: "60px",
              height: "60px",
              objectFit: "cover",
              borderRadius: "6px",
              marginLeft: "10px",
            }}
          />
          <div className="flex-grow-1">
            <h6 className="mb-1 text-primary" style={{ fontSize: "15px", fontWeight: "bold" }}>
              {job.job_title}
            </h6>
            <p className="mb-1 text-dark" style={{ fontSize: "13px" }}>
              الجهة: {job.name_operator || "غير محددة"}
            </p>
            <p className="mb-1 text-muted" style={{ fontSize: "13px" }}>
              الراتب: {job.salary || "غير محدد"}
            </p>
            <p className="mb-1" style={{ fontSize: "12px", color: "#555" }}>
              نشر بتاريخ: {job.job_publish_at || "غير محدد"}
            </p>
            <p className="mb-2" style={{ fontSize: "12px", color: "#d9534f" }}>
              آخر موعد للتقديم: {job.job_expired_at || "غير محدد"}
            </p>
            <a
              className="btn btn-sm btn-outline-primary"
              href={job.job_url}
              target="_blank"
              rel="noopener noreferrer"
            >
              عرض المزيد
            </a>
          </div>
        </div>
      </li>
    ))}
</ul>



            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
